import { Link } from "react-router-dom";
import { siteBrand, sitePrinciples } from "@/mocks/site";

export default function BrandBand() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-5">
          <span className="flex items-center gap-2 text-xs font-medium tracking-wide text-accent-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-plant-line text-base" />
            </span>
            关于我们
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一块可以随时来坐坐的瓜田
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            {siteBrand.intro}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们相信，热闹之外更值得保留的是观点本身。每一条话题都尽量给出背景与脉络，让你在围观之后还能带走点什么。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            了解黑瓜吃料
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
          {sitePrinciples.map((item) => (
            <div
              key={item.id}
              className="flex flex-col rounded-card border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}